export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тіркеу мәліметтері"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сақтау"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Расталған"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жалпы қолжетімді"])}
}